import type {
	FieldErrors,
	UseFormGetValues,
	UseFormSetValue
} from "react-hook-form";
import { formatDate } from "~/utils/DateUtil";

export const onInvalidScroll = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	errors: FieldErrors<Record<string, any>>
): void => {
	const entry = Object.entries(errors)[0];
	if (!entry) return;
	const [name, error] = entry;
	if (!error) return;

	const element =
		error.ref instanceof HTMLElement
			? error.ref
			: document.querySelector(`[name="${name}"]`);
	element?.scrollIntoView({ behavior: "smooth", block: "center" });
};

export const onChangeFile = (
	e: React.ChangeEvent<HTMLInputElement>,
	name: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>
): void => {
	const { files } = e.target;
	if (files !== null) {
		const uploadFile: File = files[0];
		setValue(name, uploadFile);
	}
};

export const onClickFileLink = (
	e: React.MouseEvent,
	name: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getValues: UseFormGetValues<any>
): void => {
	const file = getValues(name);
	if (file !== null) {
		e.preventDefault();
		const url = URL.createObjectURL(file);
		window.open(url);
	}
};

// 単体の日付入力をフォーム値に反映する
export const onChangeDate = (
	date: Date | [Date | null, Date | null] | null,
	name: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>
): void => {
	if (date === null || Array.isArray(date)) {
		setValue(name, null);
		return;
	}
	const dateStr = formatDate(date);
	setValue(name, dateStr);
};
